/** Asia/Kolkata calendar helpers for admin edition dates (YYYY-MM-DD). */

const TZ = 'Asia/Kolkata';

function partsInIST(date = new Date()) {
  const fmt = new Intl.DateTimeFormat('en-CA', {
    timeZone: TZ,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
  const map = Object.fromEntries(fmt.formatToParts(date).map((p) => [p.type, p.value]));
  return { year: map.year, month: map.month, day: map.day };
}

export function todayIST(date = new Date()) {
  const p = partsInIST(date);
  return `${p.year}-${p.month}-${p.day}`;
}

function addDaysYmd(ymd, days) {
  const [y, m, d] = String(ymd).split('-').map(Number);
  const utc = new Date(Date.UTC(y, m - 1, d));
  utc.setUTCDate(utc.getUTCDate() + days);
  const yy = utc.getUTCFullYear();
  const mm = String(utc.getUTCMonth() + 1).padStart(2, '0');
  const dd = String(utc.getUTCDate()).padStart(2, '0');
  return `${yy}-${mm}-${dd}`;
}

export function tomorrowIST(date = new Date()) {
  return addDaysYmd(todayIST(date), 1);
}

/** Furthest edition/story date admins may schedule (IST calendar days from today). */
export const SCHEDULE_HORIZON_DAYS = 30;

export function maxScheduleIST(date = new Date(), days = SCHEDULE_HORIZON_DAYS) {
  return addDaysYmd(todayIST(date), days);
}

export function isFutureEdition(ymd, now = new Date()) {
  return String(ymd) > todayIST(now);
}
